module.exports = __webpack_public_path__ + "img/scan.3901ade3.png";